export const inspirations = [
  'Biking for Babies',
  'Unplanned Movie',
  'Blogpost',
  'Email',
  'Google Search',
  'Kirk Cameron/Living Room Reset',
  'American Assoc of Christian Counselors (AACC)',
  'News/Radio/TV',
  'Referral from Friend or Family',
  'Social Media',
  'Other',
  'Heartbeat Video 2020',
]

export const donationOptions = {
  oneTime: {
    values: ['-', '-', '-', '-'],
    prefix: '',
  },
  monthly: {
    values: [10, 35, 50, 70, 105],
    prefix: '$',
  },
  yearly: {
    values: [420, 840, 1260, 2100],
    prefix: '$',
  }
}

export const crmDict = {
  STS: 'salesforce',
  VV: 'salesforce',
  FEW: 'salesforce',
}

export const siteInitialAmounts = {
  FEW: { monthly: 50 }
}

export const MIN_DONATION_PER_ATTENDEE = 35
export const MIN_DONATION = 5

const stepsFlowTypeLayoutTemplate = {
  header: false,
  footer: false,
  flowType: 'steps',
  headline: {
    title: 'Donate Today',
    titleStyle: { fontSize: 48, marginTop: 2 },
    subtitle: 'Help unlock real choice for a vulnerable woman.',
    logo_monthly_style: { height: 80 },
  },
  giftDescriptions: [
    'Future moms need you more than ever on an ongoing basis. You can help women facing unplanned pregnancies choose life and embrace the journey to motherhood... by unlocking access to free, life-saving, pro-mom care - not just today, but 365 days a year.',
    'Join Life Society, a faithful community of monthly givers helping to eliminate obstacles to montherhood.'
  ],
  initialPaymentType: 'card',
  paymentDateMenu: { visible: false },
  roundUpCheckbox: { visible: false, defaultValue: false },
  fundDisclaimer: { visible: false }, // if true of not set it'll rendered by Payment component
  successPage: { 
    surveyVisible: true, 
    redirectButtonText: 'Exit', 
    redirectAction: 'donate', 
    redirectButtonStyle: { color: '#fb534e', marginBottom: 10 },
    thankYouMediaStyle: { position: 'relative', aspectRatio: '9/12', flex: 1, paddingBottom: 10 },
    wrapperStyle: { paddingTop: 0 },
    formContainerStyle: { 
      margin: 'auto', display: 'flex', alignItems: 'center',
      maxWidth: 600, minHeight: 600, backgroundColor: 'white', borderRadius: 5,
    },
    monthlyThankYouVideo: 'https://player.vimeo.com/video/908759899?h=a6b9d5ab72',
  },
  amountImpact: { visible: false },
  paymentMethodMenu: { titleStyle: { fontSize: 48, marginTop: 0, paddingTop: 0 } },
  paymentDetails: { 
    excludedMethods: ['bank_ach_stripe'],
    titleStyle: { fontSize: 48, marginTop: 0, paddingTop: 0 },
    menuBoxStyle: { 
      boxShadow: 'none', 
      padding: 0, 
      border: '1px solid #999',
      marginBottom: 10 
    },
    // menuEntryStyle: { border: 'none', padding: 0 },
    ctaButtonStyle: { width: '100%', marginBottom: 10, maxWidth: 'unset' },
    showInputTitles: true,
    inputSize: 'lg',
    anet: { 
      cardName: { sm: 12 },
      cardNumber: { sm: 12 },
      nameOnAccount: { sm: 12 },
      routingNumber: { xs:6, sm: 6 },
      accountNumber: { xs:6, sm: 6 },
      accountType: { style: 'checkbox' },
    }
  },
  contact: {
    title: 'Contact Information',
    title2: 'Address Information',
    titleStyle: { fontSize: 48, marginTop: 0, paddingTop: 0 },
    billingAddressCheckbox: { visible: false },
    messageInput: { visible: false },
    firstName: { xs:6, sm: 6 },
    lastName: { xs:6, sm: 6 },
    email: { order: 3, sm: 12 },
    phone: { xs: 6, sm: 6 },
    company: { xs: 6, sm: 6 },
    country: { xs: 6, sm: 6, md: 6},
    state: { xs: 6, sm: 6, md: 6},
    city: { xs: 6, sm: 6, md: 6},
    zip: { xs: 6, sm: 6, md: 6},
    showInputTitles: true,
    inputSize: 'lg',
    profileToggle: { visible: false },
  },
  campaignMenu: { position: 'bottom' },
  loginButton: { visible: false },
  receiptBanner: { visible: false },
  mimicState: { visible: false },
  attachCurrentSubscription: false,
}

export const layoutConfigs = {
  '769': {
    ...stepsFlowTypeLayoutTemplate,
    headline: {
      ...stepsFlowTypeLayoutTemplate.headline,
      title_monthly: 'Join Life Society',
      subtitle_monthly: 'And support moms with real choice - every day of the year.',
      logo_monthly: 'https://donate.savethestorks.org/images/2024_LifeSociety_Logo-2.png',
    },
    ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
      ...acc,
      [`gift_descriptions_${cur}`]: [
        'Future moms need you more than ever on an ongoing basis. You can help women facing unplanned pregnancies choose life and embrace the journey to motherhood... by unlocking access to free, life-saving, pro-mom care - not just today, but 365 days a year.',
        'Consider joining our Life Society, a faithful community of monthly givers helping to eliminate obstacles to motherhood.'
      ],
    }), {})),
    disclaimerText:
      'Save the Storks is a 501(c)(3) nonprofit. Donations are tax-deductible as permitted by law and will be used to support our mission, with final discretion retained by the organization; matching gifts are applied per campaign terms.',
  },
  '813': {
    ...stepsFlowTypeLayoutTemplate,
    headline: {
      ...stepsFlowTypeLayoutTemplate.headline,
      title: 'Join Officer Brandon Tatum and Save the Storks Today!',
      titleStyle: { fontSize: 24 },
      subtitle: 'And support moms with real choice - every day of the year.',
      ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
        ...acc,
        [`hero_image_${cur}_style`]: { width: '100%', marginBottom: 5 },
        [`hero_image_${cur}`]: 'https://savethestorks.org/wp-content/uploads/2024/03/brandon-tatum.png',
      }), {})),
    },
    ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
      ...acc,
      [`gift_descriptions_${cur}`]: [
        // 'Future moms need you more than ever on an ongoing basis. You can help women facing unplanned pregnancies choose life and embrace the journey to motherhood... by unlocking access to free, life-saving, pro-mom care - not just today, but 365 days a year.',
        // 'Consider joining our Life Society, a faithful community of monthly givers helping to eliminate obstacles to motherhood.',
        'Abortion is more accessible than ever thanks to the Abortion Pills being delivered right to your door and through pharmacies across the country. Because of that, future moms need YOU more than ever on an ongoing basis. You can help women facing unplanned pregnancies choose life and embrace the journey to motherhood... by unlocking access to free, life-saving care - not just today, but 365 days a year.',
        'Your gift today will help Brandon build a Mobile Medical Clinic that will reach her first - bringing her medical testing and an ultrasound right to her. 3 out of 4 women who board a Save the Storks Mobile Medical Clinic choose life!',
        'Consider joining our Life Society, a faithful community of monthly givers helping to eliminate obstacles to motherhood.',
      ],
    }), {})),
    successPage: {
      ...stepsFlowTypeLayoutTemplate.successPage,
      additionalMessage: {
        content: 'You have made a huge life-saving difference with your donation! Thank you! We\'ll be sending you a text with a link for your free Tatum Bus Angel T-shirt.',
        minAmounts: {
          'yearly': 250,
          'monthly': 35,
          'one-time': 250,
        }
      }
    },
    // giftOptions: {
    //   title: 'Shirt Size',
    //   options: [
    //     'Small (Female)',
    //     'Small (Male)',
    //     'Medium (Female)',
    //     'Medium (Male)',
    //     'Large (Female)',
    //     'Large (Male)',
    //     'X-Large (Female)',
    //     'X-Large (Male)',
    //     '2X-Large (Female)',
    //     '2X-Large (Male)',
    //     '3X-Large (Male)',
    //     'I would like to opt out of this gift',
    //   ],
    //   minAmounts: {
    //     'yearly': 250,
    //     'monthly': 50,
    //     'one-time': 250,
    //   }
    // }
  },
  '7317991741': {
    ...stepsFlowTypeLayoutTemplate,
    headline: {
      ...stepsFlowTypeLayoutTemplate.headline,
      title: 'Join the Life Society',
      titleStyle: { fontSize: 40, marginTop: 2 },
      subtitle: 'Reach vulnerable women in a post Roe v. Wade world where abortion is MORE accessible than ever.',
      logo_monthly: 'https://donate.savethestorks.org/images/2024_LifeSociety_Logo-2.png',
    },
    startButtonText: 'Join the Life Society',
    ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
      ...acc,
      [`gift_descriptions_${cur}`]: [
        'With the rise and easy access of the abortion pill, future moms need you more than ever on an ongoing basis. You can help women facing unplanned pregnancies choose life and embrace the journey to motherhood... by unlocking access to free, life-saving care - not just today, but 365 days a year.',
        'Join a community of people like you who choose life and embrace motherhood not just as a choice, but the premier choice for women.'
      ],
    }), {})),
  },
  '7855447635': {
    ...stepsFlowTypeLayoutTemplate,
    headline: {
      ...stepsFlowTypeLayoutTemplate.headline,
      title: 'Double Your Impact',
      subtitle: 'Every dollar you give by Dec. 31 helps even more women make a brave choice.',
    },
    ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
      ...acc,
      [`gift_descriptions_${cur}`]: [
        'You can be the reason she chooses remarkable courage. You can be the one to provide the practical help she needs to embrace motherhood.',
        'Now through December 31, 2024, your year-end, tax-deductible gift will have double the impact and empower more women to choose the brave adventure of motherhood.'
      ],
    }), {})),
  },
  '9079058357': {
    ...stepsFlowTypeLayoutTemplate,
    headline: {
      ...stepsFlowTypeLayoutTemplate.headline,
      title: 'Help Launch a New Mobile Medical Clinic to Serve Northern California and Oregon',
      titleStyle: { fontSize: 24 },
      subtitle: 'And support moms with real choice - every day of the year.',
    },
  },
  '9092483296': {
    ...stepsFlowTypeLayoutTemplate,
    headline: {
      ...stepsFlowTypeLayoutTemplate.headline,
      title: 'Put Her Future First',
      titleStyle: { fontSize: 40 },
      subtitle: 'Just $13,000 to go to reach our $200,000 match!?',
    },
  }
}

layoutConfigs['8364554914'] = {
  ...layoutConfigs['769'],
  sslContent: {
    container: { style: {display: 'flex', alignItems: 'start', fontSize: 12} },
    icon: { className: 'fa-solid fa-unlock-keyhole mr1', style: {fontSize: '2.5rem', color: '#40C0DE' } },
    text: {
      style: { color: 'black' },
      content: 'We take data and privacy seriously. Your payment information is secure and will be used only to process your gift.'
    }
  }
}

layoutConfigs['9366255553'] = {
  ...layoutConfigs['769'],
  headline: {
    title: 'Golf for Life',
    titleStyle: { fontSize: 48, marginTop: 2 },
    title_monthly: 'Golf for Life',
    subtitle: 'Support moms with real choice - every day of the year.',
    subtitle_monthly: 'Support moms with real choice - every day of the year.',
    logo: null,
    logo_monthly: null,
  },
}

layoutConfigs['9295812397'] = {
  ...layoutConfigs['769'],
  headline: {
    title: 'Miles for Moms',
    titleStyle: { fontSize: 48, marginTop: 2 },
    title_monthly: 'Miles for Moms',
    subtitle: 'Give a mile. Change a life.',
    subtitle_monthly: 'Give a mile. Change a life.',
    logo: null,
    logo_monthly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Unexpected pregnancy can feel isolating—but Save the Storks mobile medical clinics brings care to her doorstep. Every dollar = a mile. You’re not just donating—you’re driving care, hope, and choice. This is your road trip with a purpose.',
      'You’re not just giving money:',
      [
        'You’re giving her a ride to safety',
        'A chance to breathe',
        'A voice to be heard',
        'Miles that matter',
      ]
    ],
  }), {})),
}

layoutConfigs['18037886096'] = {
  ...layoutConfigs['9295812397'],
  headline: {
    title: 'Deliver Hope. Double the Impact.',
    titleStyle: { fontWeight: 500, fontSize: 28 },
    title_monthly: 'Deliver Hope. Double the Impact.',
    subtitle: 'Every gift helps moms find courage, babies receive life, and families discover hope.',
    subtitle_monthly: 'Every gift helps moms find courage, babies receive life, and families discover hope.',
    subtitleStyle: { fontWeight: 500, fontSize: 18 },
    logo: null,
    logo_monthly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'This year, your generosity goes further — a $120,000 year-end match doubles the impact of every dollar you give.',
      '\\bYour Gift Delivers Hope',
      'When a mom faces an unplanned pregnancy, she often feels scared and alone. But because of you, her story changes.',
      'Your gift doesn’t just fund services — it delivers hope, transforms fear into faith, and turns uncertainty into life.',
      '\\bGive Today. Unlock the $120,000 Match.',
      'Your year-end gift ensures we can step into 2026 ready to:',
      [
        'Empower more moms',
        'Save more babies',
        'Share God’s love'
      ],
      '\\bThank you |for helping deliver hope where it’s needed most.'
    ],
  }), {})),
  startButtonAdditionalText: 'All donations will be matched, up to $120,000 or until midnight on December 31, 2025. If we meet our match goal prior to receiving your one-time donation, your donation will not be matched but will still go to support our programs.',
}

layoutConfigs['10601303908'] = {
  ...layoutConfigs['18037886096'],
  headline: {
    ...layoutConfigs['18037886096'].headline,
    title: 'Today is Colorado Gives Day — and your gift is |\\idoubled.',
    title_monthly: 'Today is Colorado Gives Day — and your gift is |\\idoubled.',
    subtitle: 'One day. One mission. Double the hope.',
    subtitle_monthly: 'One day. One mission. Double the hope.',
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Colorado is where our movement began, and for the next 24 hours, your generosity goes twice as far to deliver life-saving care to women, men, and families.',
      'Thanks to a $200,000 match, every dollar you give equips our Mobile Medical Clinics, protects life, and strengthens families with compassion and truth.',
      'Your gift today brings twice the care and twice the impact.',
      'Thank you for delivering hope to Colorado.',
      'Give today and unlock the $200,000 match!',
    ],
  }), {})),
  startButtonAdditionalText: 'All donations will be matched, up to $200,000 or until midnight on December 9, 2025. If we meet our match goal prior to receiving your one-time donation, your donation will not be matched but will still go to support our programs.'
}

layoutConfigs['10543007364'] = {
  ...layoutConfigs['18037886096'],
  headline: {
    ...layoutConfigs['18037886096'].headline,
    title: 'We need YOUR help today!',
    title_monthly: 'We need YOUR help today!',
    subtitle: 'Honor Charlie Kirk’s Legacy with a Gift of Hope',
    subtitle_monthly: 'Honor Charlie Kirk’s Legacy with a Gift of Hope',
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Because 4 out of 5 women who board a Mobile Medical Clinic choose life, you can be certain your donation will save lives. Your gift will help fund more Mobile Clinics in honor of Charlie Kirk\'s legacy. Thank you for your generosity today!'
    ],
  }), {})),
  startButtonAdditionalText: null,
}

layoutConfigs['9422776430'] = {
  ...layoutConfigs['769'],
  headline: {
    title: 'Give the Gift of Motherhood',
    titleStyle: { fontSize: 32, marginTop: 2 },
    subtitle: 'Help Her Choose Life',
    ['logo_one-time']: null,
    logo_monthly: null,
    logo_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'You can bring hope to women facing unplanned pregnancies. Through our mobile medical clinics, we provide free ultrasounds and compassionate care—right where she needs it most.',
      'When she steps onto that mobile medical clinic, she\'ll see her baby on an ultrasound for the very first time and hear her baby’s heartbeat. And it is on these state-of-the-art mobile clinics where she\'ll choose life 3 out of 4 times*.',
      'Would you prayerfully consider giving $20 a month to give her the gift of motherhood?',
    ],
  }), {})),
}

layoutConfigs['9394795830'] = {
  ...layoutConfigs['813'],
  headline: {
    ...layoutConfigs['813'].headline,
    title: 'Officer Brandon Tatum and Save the Storks need YOUR help today!',
    subtitle: 'And provide a Bundle of Hope to a mom in need of courage this season',
    titleStyle: { fontSize: 24 },
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Imagine a woman, scared and alone, facing an unplanned pregnancy. She doesn’t know if she can do this. Then Save the Storks steps in —and because of donors like you - we are able to place a Bundle of Hope in her hands. It’s more than practical help—it’s a message: “You are not alone. There is hope.”',
      'For just $50, you can deliver that hope. You can give a mother courage, a baby protection, and a family the chance to thrive. Every Bundle of Hope you provide is a lifeline in a moment of crisis.',
      'When you give, you aren’t just writing a check—you are Delivering Hope. You are stepping into her story at the very moment she needs someone to believe in her.',
      'Your generosity turns fear into peace, despair into possibility, and loneliness into love. Every dollar goes directly to helping women in unplanned pregnancies choose life and find strength for the journey ahead.',
      'Together, we can deliver hope to women and babies all year long—one Bundle of Hope at a time.',
      'Every dollar goes directly to helping women in unplanned pregnancies choose life and find strength for the journey ahead.',
      'When you give, you’re not just making a donation—you’re Delivering Hope.'
    ],
  }), {})),
}

layoutConfigs['18335271862'] = {
  ...layoutConfigs['9394795830'],
  headline: {
    ...layoutConfigs['9394795830'].headline,
    title: 'Brandon Tatum and Save the Storks Need YOUR Help Today',
    subtitle: 'Your Gift Reaches Women Before an Abortion Pill Arrives in Their Mailbox',
    subtitle_monthly: 'Your Gift Reaches Women Before an Abortion Pill Arrives in Their Mailbox',
    ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
      ...acc,
      [`hero_image_${cur}`]: null,
    }), {})),
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Abortion pills arrive before a woman sees the life inside her or knows she has support. Save the Storks Mobile Medical Clinics bring care, guidance, and life-affirming options. Give today—deliver hope and Let Life Happen.'
    ],
  }), {})),
  // giftOptions: {
  //   title: 'Please select the size for your Life Army T-Shirt',
  //   options: [
  //     'Opt-Out',
  //     'S',
  //     'M',
  //     'L',
  //     'XL',
  //     '2XL',
  //     '3XL',
  //   ],
  //   optionTitles: {
  //     'Opt-Out': 'No thanks',
  //   },
  //   minAmounts: {
  //     default: 50,
  //   },
  //   apiName: 't_shirt_size__c'
  // }
}

layoutConfigs['9486869239'] = {
  ...layoutConfigs['769'],
  headline: {
    title: 'Equal Access to Motherhood',
    titleStyle: { fontSize: 32, marginTop: 2 },
    subtitle: 'BECAUSE PURSUING MOTHERHOOD SHOULDN’T FEEL IMPOSSIBLE',
    ['logo_one-time']: null,
    logo_monthly: null,
    logo_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'At Save the Storks, our mission is to create a story of hope and empowerment for every woman facing an unplanned pregnancy. We believe that every woman deserves equal access to Motherhood — to the care, support, and community she needs to confidently choose life and thrive.',
      'Empowering her requires more than a single moment, it demands a cultural shift, a new standard of compassion, and a strong ecosystem that surrounds her with real options and unwavering support.',
    ],
  }), {})),
}

layoutConfigs['9725043538'] = {
  ...layoutConfigs['769'],
  headline: {
    title: 'Colorado Mobile Medical Clinic',
    titleStyle: { fontSize: 32, marginTop: 2 },
    subtitle: 'Double your impact to bring a new Mobile Medical Clinic to Colorado',
    ['logo_one-time']: null,
    logo_monthly: null,
    logo_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'In a state where abortion is common, imagine if women in Colorado—and those traveling here—had access to ultrasounds, pregnancy tests, STI care, and compassionate support. What if Colorado became known not for abortion tourism, but for life-affirming care for women?',
      'Would you prayerfully consider giving a gift today to be part of this Colorado mission? Every dollar you give will be matched. $100 becomes $200. $500 becomes $1,000. And every mile that Mobile Medical Clinic travels will be powered by your generosity.'
    ],
  }), {})),
}

layoutConfigs['9656209794'] = {
  ...layoutConfigs['769'],
  headline: {
    title: 'Help Women Choose Life with Compassionate Care',
    titleStyle: { fontSize: 24, marginTop: 2, color: '#fff' },
    subtitle: 'More women are turning to abortion—your support offers a life-affirming alternative.',
    subtitleStyle: { color: '#fff', fontSize: 14, fontWeight: 'bold', fontFamily: "'Montserrat', sans-serif", marginBottom: 20 },
    ['logo_one-time']: null,
    logo_monthly: null,
    logo_yearly: null,
  },
  startButtonAdditionalText: 'Consider joining our Life Society, a faithful community of monthly givers helping to eliminate obstacles to motherhood.',
  container: {
    style: {
      backgroundColor: '#2A647D',
      color: '#fff',
      // donateButtonBorder: '1px solid #fff',
      // errorMessageColor: '#fb534e',
      // errorMessageColor: '#fff',
      // errorMessageBackgroundColor: '#f17284',
      // subtextColor: '#fff',
      // borderRadius: 10,
      additionalStyles: `
        .btn-donate {
          border: 1px solid #fff !important;
        }
        .error-message, 
        .is-invalid~.invalid-feedback,
        .invalid-feedback.invalid-inspiration-feedback.invalid,
        .invalid-feedback.invalid-country-feedback.invalid {
          color: #fff !important;
          background-color: #f17284;
          display: inline-block !important;
          width: auto;
          padding: 3px;
          border-radius: 3px;
          margin-top: 5px;
        }
        label>span, .pre-field, .form-check-label {
          color: #fff !important;
        }
        .required:after {
          color: #fb534e;
        }
      `
    }
  },
  contact: {
    ...layoutConfigs['769'].contact,
    titleStyle: { 
      ...layoutConfigs['769'].contact.titleStyle,
      color: '#fff', 
    },
  },
  paymentDetails: {
    ...layoutConfigs['769'].paymentDetails,
    titleStyle: {
      ...layoutConfigs['769'].paymentDetails.titleStyle,
      color: '#fff',
    },
    menuBoxStyle: {
      ...layoutConfigs['769'].paymentDetails.menuBoxStyle,
      color: '#212529',
    },
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Women facing unexpected pregnancies need care and support they can trust.',
      'Your gift provides free, life-affirming services and resources that empower them to choose life and embrace motherhood.',
      '\\bDonate today to give hope and real help.',
    ],
  }), {})),
}

layoutConfigs['9717694586'] = {
  ...stepsFlowTypeLayoutTemplate,
  container: {
    style: {
      padding: '0px !important',
      additionalStyles: `
        .btn-primary.dropdown-toggle {
          border-radius: 0.25rem !important;
          border: 1px solid #ced4da !important;
        }
        .btn-primary.dropdown-toggle:hover {
          color: unset !important;
          border: 2px solid var(--cf-green) !important;
        }
      `
    },
  },
}

layoutConfigs['18140404039'] = {
  ...stepsFlowTypeLayoutTemplate,
  headline: {
    ...stepsFlowTypeLayoutTemplate.headline,
    title: 'Honor Charlie Kirk’s Legacy',
    title_monthly: 'Honor Charlie Kirk’s Legacy',
    titleStyle: { fontSize: 32 },
    subtitle: 'You Can Carry His Mission for Life Forward',
    subtitle_monthly: 'You Can Carry His Mission for Life Forward',
    ['logo_one-time']: null,
    logo_monthly: null,
    logo_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Charlie Kirk’s bold voice for life and family continues to inspire us to stand for truth, protect the unborn, and strengthen families across America. His conviction was clear: every life has value, and every family matters.',
      'This is why Save the Storks exists.',
      'For over a decade, we’ve followed that same mission, saving lives and serving women by equipping Pregnancy Health Clinics at no cost. Through Save the Storks Mobile Medical Clinics, strategic partnerships, and national outreach, we provide real choices and life-affirming care.',
      'But we can’t do this alone. Your support ensures Charlie’s legacy lives on and that women continue to hear a message of hope and tangible help.',
      'Your gift today can help:',
      [
        'Expand Save the Storks Mobile Medical Clinics with free ultrasounds, pregnancy testing, and counseling.',
        'Strengthen 100+ Pregnancy Clinics with resources and support.',
        'Provide a Digital Ecosystem for women that meets them anywhere with real care and options.',
        'Offer Holistic Care like housing, job training, and parenting education.',
      ],
      'Giving in Charlie’s honor means defending life, uplifting mothers, and carrying forward the values he lived by. Use the secure form below to give today.'
    ]
  }), {})),
}

layoutConfigs['9903982797'] = {
  ...layoutConfigs['769'],
  headline: {
    ...layoutConfigs['769'].headline,
    subtitle: 'You Can Help Women Choose Life and Hope',
    subtitle_monthly: 'You Can Help Women Choose Life and Hope',
    title: 'Join Life Society',
    title_monthly: 'Join Life Society',
    titleStyle: { display: 'none' },
    logo: null,
    logo_monthly: null,
    logo_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Your gift today can help:',
      [
        'Expand Save the Storks Mobile Medical Clinics for Expecting Moms with free ultrasounds and counseling.',
        'Strengthen 100+ Save the Storks Partner Clinics with resources and support.',
        'Provide a Digital Ecosystem for women that meets them anywhere with real care and options.',
        'Offer Holistic Care like housing, job training, and parenting education.',
      ],
      'Supporting Save the Storks means |\\bsaving lives, uplifting mothers, and creating a culture where life is cherished.| Use the secure form below to give today.'
    ]
  }), {})),
  disclaimerText:
    'Save the Storks is a 501(c)(3) nonprofit. Donations are tax-deductible as permitted by law and will be used to support our mission, with final discretion retained by the organization; matching gifts are applied per campaign terms.',
}

layoutConfigs['11644219598'] = {
  ...layoutConfigs['9903982797'],
  headline: {
    ...layoutConfigs['9903982797'].headline,
    subtitle: 'Your Gift will help women and babies!',
    subtitle_monthly: 'Your Gift will help women and babies!',
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Your gift can provide the impact needed to allow us to reach more women and save more babies. Your support of Save the Storks means creating a culture where life is cherished. Please give today.',
    ]
  }), {})),
}

layoutConfigs['12065429443'] = {
  ...layoutConfigs['9903982797'],
  headline: {
    ...layoutConfigs['9903982797'].headline,
    title: 'Be Bold. Give Hope.',
    title_monthly: 'Be Bold. Give Hope.',
    title_yearly: 'Be Bold. Give Hope.',
    titleStyle: { fontSize: 32, color: '#fb534e' },
    subtitle: null,
    subtitle_monthly: null,
    subtitle_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Your gift helps Save the Storks bring hope and life-affirming care to women facing unexpected pregnancies through Mobile Medical Clinics nationwide.',
      'Every donation helps provide free ultrasounds, pregnancy services, and compassionate support to women who need it most.',
      '\\bGive today and help change a story forever.',
    ]
  }), {})),
  disclaimerText:
    'Save the Storks is a 501(c)(3) nonprofit. Donations are tax-deductible as permitted by law and will be used to support our mission, with final discretion retained by the organization; matching gifts are applied per campaign terms.',
}

layoutConfigs['12075201356'] = {
  ...layoutConfigs['9903982797'],
  headline: {
    ...layoutConfigs['9903982797'].headline,
    title: 'Reach Her Today!',
    title_monthly: 'Reach Her Today!',
    title_yearly: 'Reach Her Today!',
    titleStyle: { fontSize: 32, color: '#fb534e' },
    subtitle: null,
    subtitle_monthly: null,
    subtitle_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Your gift helps bring compassionate, life-affirming care directly to women facing unexpected pregnancies in Colorado through Save the Storks.',
      'Every donation supports free ultrasounds, pregnancy services, and ongoing support for women who need hope and real options.',
      'Together, we can meet women where they are and help change lives for generations to come.',
      '\\bGive today and make a lasting impact.',
    ]
  }), {})),
  disclaimerText:
    'Save the Storks is a 501(c)(3) nonprofit. Donations are tax-deductible as permitted by law and will be used to support our mission, with final discretion retained by the organization; matching gifts are applied per campaign terms.',
  defaultCampaignId: '701Pd000010kQ0dIAE',
}

layoutConfigs['12128927531'] = {
  ...layoutConfigs['9903982797'],
  headline: {
    ...layoutConfigs['9903982797'].headline,
    title: 'Fathers Matter, Too',
    title_monthly: 'Fathers Matter, Too',
    title_yearly: 'Fathers Matter, Too',
    titleStyle: { fontSize: 32, color: '#fb534e' },
    subtitle: null,
    subtitle_monthly: null,
    subtitle_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      "This Father's Day, honor the dads who choose courage, love, and life for their families.",
      'Your gift helps provide hope, free ultrasounds, and compassionate support for moms and dads facing unexpected pregnancies.',
      'Give Today',
    ]
  }), {})),
  disclaimerText:
    'Save the Storks is a 501(c)(3) nonprofit. Donations are tax-deductible as permitted by law and will be used to support our mission, with final discretion retained by the organization; matching gifts are applied per campaign terms.',
}

layoutConfigs['10928715893'] = {
  ...layoutConfigs['9903982797'],
  headline: {
    ...layoutConfigs['9903982797'].headline,
    title: 'YOU Inspire Us',
    title_monthly: 'YOU Inspire Us',
    title_yearly: 'YOU Inspire Us',
    titleStyle: { fontSize: 32, color: '#fb534e' },
    subtitle: null,
    subtitle_monthly: null,
    subtitle_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Because of your faithful giving and prayer, women facing unexpected pregnancies find real hope and support. Your generosity helps provide compassionate care, clear answers, and a path forward for moms, dads, and their babies.',
      '\\bYou inspire life.',
      'Give now and help make hope possible.'
    ]
  }), {})),
}

layoutConfigs['11174869570'] = {
  ...layoutConfigs['9903982797'],
  headline: {
    ...layoutConfigs['9903982797'].headline,
    title: 'Every Day You Can Help Women Choose Life',
    title_monthly: 'Every Day You Can Help Women Choose Life',
    title_yearly: 'Every Day You Can Help Women Choose Life',
    titleStyle: { fontSize: 20, color: '#fb534e' },
    subtitle: null,
    subtitle_monthly: null,
    subtitle_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Your monthly gift can help:',
      [
        'Expand Save the Storks Mobile Medical Clinics with free ultrasounds, pregnancy testing, and counseling.',
        'Strengthen 100+ Pregnancy Clinics with resources and support.',
        'Provide a Digital Ecosystem for women that meets them anywhere with real care and options.',
        'Offer Holistic Care like housing, job training, and parenting education.',
      ],
      'Supporting Save the Storks means|\\b saving lives, uplifting mothers, and creating a culture where life is cherished.| Use the secure form below to give today.',
      'For this month only, if you give $25/month or more, you will receive a tote and journal with your gift!'
    ]
  }), {})),
  giftOptions: {
    title: 'I do not wish to receive the tote bag and journal',
    checkBox: true,
    defaultValue: false,
    optionValues: {
      true: 'Opt-Out: tote bag and journal',
      false: 'Yes: tote bag and journal',
    },
    minAmounts: {
      monthly: 25,
      yearly: Infinity,
      ['one-time']: Infinity,
    },
    apiName: 't_shirt_size__c'
  }
}

layoutConfigs['18089738292'] = {
  ...layoutConfigs['9903982797'],
  headline: {
    ...layoutConfigs['9903982797'].headline,
    title: 'Deliver Hope',
    title_monthly: 'Deliver Hope',
    title_yearly: 'Deliver Hope',
    titleStyle: { fontSize: 32 },
    logo: null,
    ['logo_one-time']: null,
    logo_monthly: null,
    logo_yearly: null,
  },
}

layoutConfigs['11375424288'] = {
  ...layoutConfigs['9903982797'],
  headline: {
    ...layoutConfigs['9903982797'].headline,
    title: 'Your Gift will be Matched 2x!',
    title_monthly: 'Your Gift will be Matched 2x!',
    title_yearly: 'Your Gift will be Matched 2x!',
    titleStyle: { fontSize: 32, color: '#fb534e' },
    subtitle: null,
    subtitle_monthly: null,
    subtitle_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      '\\bYour gift can provide double the impact allowing us to reach more women and save more babies. Your support of Save the Storks means creating a culture where life is cherished. Please give today.',
    ]
  }), {})),
  disclaimerText: '\\bEvery gift will be doubled up to our goal of $10K if received by April 30, 2026. All gifts received in excess will be put into our Donor Match Fund. We will use your gift wherever the need is greatest.',
}

layoutConfigs['11860958661'] = {
  ...layoutConfigs['11375424288'],
  headline: {
    ...layoutConfigs['11375424288'].headline,
    title: 'Joy Begins with a First Look',
    title_monthly: 'Joy Begins with a First Look',
    title_yearly: 'Joy Begins with a First Look',
    titleStyle: { fontSize: 32, color: '#fb534e' },
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'She walked in uncertain. Then she saw her baby for the first time—a heartbeat, a tiny movement, a life made real. In that moment, everything changed. Your gift brings Mobile Medical Clinics and support to women in need, creating hope, clarity, and the beginning of joy.',
      'Give Today',
    ]
  }), {})),
  startButtonText: 'Give Today',
  disclaimerText:
    'Save the Storks is a 501(c)(3) nonprofit. Donations are tax-deductible as permitted by law and will be used to support our mission, with final discretion retained by the organization; matching gifts are applied per campaign terms.',
  defaultCampaignId: '701Pd00000zD8RNIA0',
}

/** Match campaign: stepped flow; mobile guests get name/email/zip via shared stsMobileGuest logic. Layout id doubles as default Salesforce CID. */
const stsMatchCompactLayoutBase = {
  ...layoutConfigs['11375424288'],
  flowType: 'steps',
  disclaimerText:
    '\\bEvery gift will be doubled up to our goal of $10K if received by June 30, 2026. All gifts received in excess will be put into our Donor Match Fund. We will use your gift wherever the need is greatest.',
  campaignMenuVisible: false,
}

layoutConfigs['701Pd000017orw8IAA'] = {
  ...stsMatchCompactLayoutBase,
  defaultCampaignId: '701Pd000017orw8IAA',
}

layoutConfigs['701Pd00001CTPelIAH'] = {
  ...stsMatchCompactLayoutBase,
  defaultCampaignId: '701Pd00001CTPelIAH',
}

layoutConfigs['701Pd00001EBspLIAT'] = {
  ...stsMatchCompactLayoutBase,
  defaultCampaignId: '701Pd00001EBspLIAT',
  disclaimerText:
    '\\bEvery gift will be doubled up to our goal of $25K if received by September 30, 2026. All gifts received in excess will be put into our Donor Match Fund. We will use your gift wherever the need is greatest.',
}

layoutConfigs['12205623779'] = {
  ...layoutConfigs['701Pd00001EBspLIAT'],
  defaultCampaignId: '701Pd00001KpPQAIA3',
  headline: {
    ...layoutConfigs['701Pd00001EBspLIAT'].headline,
    title: "Celebrate America's 250th Birthday & Get a Free Mini Tote!",
    title_monthly: "Celebrate America's 250th Birthday & Get a Free Mini Tote!",
    title_yearly: "Celebrate America's 250th Birthday & Get a Free Mini Tote!",
    titleStyle: { fontSize: 28, color: '#fb534e' },
    subtitle: null,
    subtitle_monthly: null,
    subtitle_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      "As we celebrate America's 250th birthday, your gift helps Save the Storks bring hope, support, and care to women and families across the nation so that more babies in America can celebrate their birthdays.",
      '\\bGive any amount today and receive an exclusive mini tote bag available to the first 200 donors.',
    ]
  }), {})),
  giftOptions: {
    title: 'I do not wish to receive the mini tote bag',
    checkBox: true,
    defaultValue: false,
    optInMessagePrefix: 'Mini tote preference',
    requireAddressWhenOptedIn: true,
    optionValues: {
      true: 'NoTote',
      false: 'YesTote',
    },
    apiName: 't_shirt_size__c',
  },
  disclaimerText:
    'Save the Storks is a 501(c)(3) nonprofit. Donations are tax-deductible as permitted by law and will be used to support our mission, with final discretion retained by the organization; matching gifts are applied per campaign terms.',
  disclaimerTextAboveSsl:
    '\\b Terms & Conditions\n1. Must be 18+ years of age.\n2. Offer runs while supplies lasts, limited to the first 200 eligible participants.\n3. Shipping only available within the lower 48 states (excludes Alaska, Hawaii, and any non United States address).\n4. To receive a complimentary tote bag, participants must complete the donation form, provide valid contact information, and submit an accurate U.S. shipping address.\n5. Save the Storks reserves the right to modify, suspend, or terminate this promotion at any time without prior notice.\n6. This promotion is in no way sponsored, endorsed, administered by, or associated with Facebook, Instagram, or Meta. By participating, you release Facebook, Instagram, and Meta from any responsibility or liability related to this promotion.\n7. In case of questions, please contact \\m info@savethestorks.org',
  successPage: {
    surveyVisible: false,
    hideThankYouVideo: true,
    hideThankYouMedia: true,
    redirectButtonText: 'Follow Us on Instagram',
    redirectButtonUrl: 'https://www.instagram.com/savethestorks',
    thankYouTitle: "Now Join Storky's Road Trip Across America!",
    thankYouContentBlocks: [
      'Thank you for supporting life. Your partnership is helping mothers choose life and making it possible for new families to begin across America.',
      "Now join Storky's Road Trip Across America!",
      '\\bDownload Flat Storky below and take Storky along on all your summer adventures|—whether you\'re headed to the beach, the mountains, a baseball game, a backyard BBQ, or a family road trip.',
      '📸 Snap a photo with Flat Storky and share it on social media. Be sure to tag us @savethestorks and use our hashtags #SummerWithStorky and #FlatStorky so we can follow along on the journey!',
      '📲 Follow us on Instagram by scanning the QR code below and follow along on the journey!',
      "We can't wait to see where Storky travels next!",
    ],
    thankYouDownloadLink: {
      url: 'https://savethestorks.org/wp-content/uploads/2026/06/2026_FlatStorky.pdf',
      text: 'Download Flat Storky',
    },
    thankYouQrCodeImageUrl: '/server/assets/images/flat-storky-instagram-qr.png',
    formContainerStyle: {
      margin: 'auto',
      maxWidth: 600,
      backgroundColor: 'white',
      borderRadius: 5,
      padding: '1.5rem',
    },
    thankYouMediaStyleNoVideo: { position: 'relative', paddingBottom: 10 },
  },
}

layoutConfigs['12562251371'] = {
  ...layoutConfigs['12205623779'],
  headline: {
    ...layoutConfigs['12205623779'].headline,
    title: 'Celebrate Life This Summer',
    title_monthly: 'Celebrate Life This Summer',
    title_yearly: 'Celebrate Life This Summer',
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      "When you make a gift today, you'll receive an exclusive Save the Storks Mini Tote Bag as our thank-you.",
      "Your generosity helps Save the Storks reach women with compassionate, life-affirming care before they face the life-changing decision. Through our nationwide fleet of Mobile Medical Clinics and partnerships with Pregnancy Health Clinics, we're meeting women with hope, medical care, and support when they need it most.",
    ]
  }), {})),
  giftOptions: {
    ...layoutConfigs['12205623779'].giftOptions,
    requireMailingAddress: true,
  },
  successPage: {
    ...layoutConfigs['701Pd00001EBspLIAT'].successPage,
  },
}

layoutConfigs['12562267711'] = {
  ...layoutConfigs['12562251371'],
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      ...layoutConfigs['12562251371'][`gift_descriptions_${cur}`],
      '\\bGive today. Save a life. Receive your exclusive mini tote while supplies last.',
    ]
  }), {})),
}

layoutConfigs['10055012639'] = {
  ...layoutConfigs['769'],
  headline: {
    ...layoutConfigs['769'].headline,
    title: 'Celebrate Life',
    title_monthly: 'Celebrate Life',
    subtitle: 'Together, We Can Give More Families the Chance to Celebrate Life',
    subtitle_monthly: 'Together, We Can Give More Families the Chance to Celebrate Life',
    ['logo_one-time']: null,
    logo_monthly: null,
    logo_yearly: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'Every family deserves to thrive, and every life is a gift. Your generosity makes that possible.',
      'With your support, mothers in their most vulnerable moments find hope, courage, and the strength to choose life—for their babies and for their futures.',
      'This is more than a mission—it’s a celebration of life and families. And you are a vital part of it.',
      'How Your Gift Helps',
      'Your donation is more than a number—it’s a lifeline for a mother and her child:',
      [
        '$50 helps provide counseling and care for a mother in need.',
        '$100 helps equip a mobile medical unit to serve families in crisis.',
        '$250 helps ensure more families hear the message of love, compassion, and life.'
      ],
      'Tonight, a mother may feel completely alone and without support. With your help, she can find the strength to choose life and the hope of a brighter future.',
      'You are the difference between fear and courage, despair and possibility, isolation and belonging.',
      'Together, we can ensure more families experience the joy of life. Thank you for standing with us in this mission.'
    ],
  }), {})),
}

layoutConfigs['vv-202510211250'] = {
  ...stepsFlowTypeLayoutTemplate,
  headline: {
    ...stepsFlowTypeLayoutTemplate.headline,
    title: 'FIERCE LOVE, TENDER CARE',
    titleStyle: { fontSize: 32 },
    subtitle: null,
    logo: null,
  },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      'We’re on a mission to walk with Mamas carrying to term despite a prenatal diagnosis. With fierce love and tender care, we change stories from heartache to hope. Your monthly gift helps us:',
      [
        'Provide personalized support to Mama Bears',
        'Sustain vital programs that bring connections and hope',
        'Expand our reach to connect with more mothers in need'
      ]
    ],
  }), {})),
}


layoutConfigs['vv-202605211200'] = {
  ...layoutConfigs['vv-202510211250'],
  headline: {
    ...layoutConfigs['vv-202510211250'].headline,
    title: 'FIERCE LOVE, TENDER CARE',
    title_monthly: 'FIERCE LOVE, TENDER CARE',
    title_yearly: 'FIERCE LOVE, TENDER CARE',
  },
  initialDonationType: 'one-time',
  onlyShowTypes: ['one-time'],
  donationTypeMenu: { visible: false },
  ...(['one-time', 'monthly', 'yearly'].reduce((acc, cur) => ({
    ...acc,
    [`gift_descriptions_${cur}`]: [
      "We would love to honor the Spitzenberger Family's journey through our Legacy Story Project. This video testimonial gives families a tangible record of their experiences from diagnosis to delivery and beyond, a story that powerfully shows the value of all human life and the love each family embraces in the midst of heart-wrenching circumstances.",
      'Your one-time donation on this page will go directly to fund the videography, editing, and travel expenses to bring this project to life.',
    ],
  }), {})),
  defaultCampaignId: '701Po00001nZcKDIA0',
  successPage: {
    ...layoutConfigs['vv-202510211250'].successPage,
    surveyVisible: false,
    redirectButtonText: 'Donate Again',
    formContainerStyle: {
      margin: 'auto',
      maxWidth: 600,
      backgroundColor: 'white',
      borderRadius: 5,
      padding: '1.5rem',
    },
    thankYouMediaStyleNoVideo: { position: 'relative', paddingBottom: 10 },
  },
}
